// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3YfhY","rightAdornment":"Header_rightAdornment__B2JJi"};